import { StyleSheet } from "aphrodite";

const stack = "@media (max-width: 768px)";

export const dashboardCardStyles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    width: "100%",
    padding: 20,
    boxSizing: "border-box",
    backgroundColor: "white",
    position: "relative",
    zIndex: 3,
    overflow: "visible",
    [stack]: {
      flexDirection: "column",
      alignItems: "stretch",
      padding: 12,
    },
  },
  title: {
    color: "#495057",
    fontSize: 18,
    fontWeight: "bold",
    margin: "5px 0",
    minWidth: 0,
    [stack]: { fontSize: 16, width: "100%" },
  },
  filters: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
    [stack]: {
      flexDirection: "column",
      width: "100%",
      alignItems: "stretch",
    },
  },
  field: {
    width: 220,
    minWidth: 0,
    [stack]: { width: "100%", maxWidth: "100%" },
  },
  fieldNarrow: {
    width: 140,
    minWidth: 0,
    [stack]: { width: "100%", maxWidth: "100%" },
  },
  chartBody: {
    width: "100%",
    padding: "20px 30px",
    boxSizing: "border-box",
    backgroundColor: "white",
    overflowX: "auto",
    [stack]: { padding: "12px 8px" },
  },
});
